'use client';
import Hooks from '@benzinga/hooks';
import { FullDataField, QuotesV3FieldsManager } from '@benzinga/quotes-v3-fields-manager';
import { SessionContext } from '@benzinga/session-context';
import React from 'react';

export const useScannerColumnableDefs = () => {
  const session = React.useContext(SessionContext);
  const [scannerDefs, setScannerDefs] = React.useState<FullDataField[] | undefined>(() =>
    session.getManager(QuotesV3FieldsManager).getColumableFields(),
  );

  React.useEffect(() => {
    session.getManager(QuotesV3FieldsManager);
  }, [session]);

  Hooks.useSubscriber(session.getManager(QuotesV3FieldsManager), event => {
    switch (event.type) {
      case 'quotes_fields:update':
        setScannerDefs(session.getManager(QuotesV3FieldsManager).getColumableFields());
        break;
    }
  });

  return scannerDefs;
};
